<div class="vm-tile-wrapper">
  <vm-selectable-card
    class="vm-card-view"
    *ngFor="let selectableCard of selectableCards"
    [selectableCard]="selectableCard"
    [includeModalOkButton]="includeModalOkButton"
    (click)="selectProduct(selectableCard)"
    [isChecked]="
      (checkboxProductMap.get(selectableCard.productId) && selectableCard.isRadioOrCheckBox === 'Checkbox') ||
      (radioProductMap.get(selectableCard.productId) && selectableCard.isRadioOrCheckBox === 'Radio')
    "
    role="button"
    id="product_{{ selectableCard.productId }}"
    [headingMultiLineHeight]="headingMultilineHeight"
    (addToggleOption)="addSelectedToggleOption($event)"
    (removeToggleOption)="removeSelectedToggleOption($event)"
    (resetCheckedState)="updateStoredCheckedState($event)"
    [isGroupHavingToggle]="isGroupHavingToggle"
    [includedTextVisibility]="includedTextVisibility"
    [chargesTextVisibility]="chargesTextVisibility"
    [includeSecondaryCloseButton]="includeSecondaryCloseButton"
    [imgSizeManipulation]="imgSizeManipulation"
    tabindex="-1"
  >
  </vm-selectable-card>
</div>
